import { render, staticRenderFns } from "./pointsMall.vue?vue&type=template&id=7b9344ce&scoped=true&"
import script from "./pointsMall.vue?vue&type=script&lang=js&"
export * from "./pointsMall.vue?vue&type=script&lang=js&"
import style0 from "./pointsMall.vue?vue&type=style&index=0&id=7b9344ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9344ce",
  null
  
)

export default component.exports